module.exports = __webpack_public_path__ + "img/logo.d650001a.png";